import { ArrowRight, Moon, Sun } from "lucide-react";

export const MOMENTS = {
  day: { label: "Rituale del giorno", short: "Giorno", Icon: Sun, sub: "Protezione e luminosità per affrontare la giornata.", when: "Al mattino" },
  night: { label: "Rituale della sera", short: "Sera", Icon: Moon, sub: "Doppia detersione e rigenerazione mentre riposi.", when: "Prima di dormire" },
};

const theme = {
  day: { card: "bg-[#FBF3E3] border-[#EBD9B4] text-[#1A1A18]", icon: "bg-[#C5A059] text-[#FAF8F5]", muted: "text-[#8C6F3E]", ring: "ring-[#C5A059]" },
  night: { card: "bg-[#1A1A18] border-[#1A1A18] text-[#FAF8F5]", icon: "bg-[#FAF8F5]/10 text-[#E8DEC8] border border-[#E8DEC8]/40", muted: "text-[#B8B0A4]", ring: "ring-[#C5A059]" },
};

export const MomentSwitch = ({ moment, counts, onChange }) => (
  <div className="mt-10" data-testid="moment-switch">
    <p className="fs-eyebrow">Due rituali, una sola pelle</p>
    <div className="mt-4 grid grid-cols-2 gap-3 sm:gap-4" role="tablist">
      {Object.entries(MOMENTS).map(([key, m]) => {
        const t = theme[key]; const active = moment === key;
        return (
          <button key={key} data-testid={`routine-tab-${key}`} role="tab" aria-selected={active} onClick={() => onChange(key)}
            className={`relative text-left p-4 sm:p-6 border rounded-[20px] transition-all duration-300 ${t.card} ${active ? `ring-2 ring-offset-2 ring-offset-[#FAF8F5] ${t.ring} shadow-[0_18px_40px_-24px_rgba(26,26,24,.45)]` : "opacity-70 hover:opacity-100 scale-[0.985]"}`}>
            <span className={`inline-flex h-10 w-10 sm:h-12 sm:w-12 items-center justify-center rounded-full ${t.icon}`}><m.Icon size={20} strokeWidth={1.4} /></span>
            <span className={`block text-[10px] tracking-[0.24em] uppercase mt-4 ${t.muted}`}>{m.when}</span>
            <span className="block font-serif text-lg sm:text-2xl leading-tight mt-1">{m.label}</span>
            <span className={`block text-xs mt-2 ${t.muted}`} data-testid={`routine-tab-${key}-count`}>{counts[key].steps} step{counts[key].extras ? ` + ${counts[key].extras} extra settimanale` : ""}</span>
            {active && <span className={`hidden sm:block absolute top-4 right-4 text-[10px] tracking-[0.2em] uppercase ${t.muted}`}>Stai vedendo</span>}
          </button>
        );
      })}
    </div>
  </div>
);

export const MomentBanner = ({ moment }) => {
  const m = MOMENTS[moment]; const t = theme[moment];
  return (
    <div className={`mt-8 flex items-center gap-4 px-5 py-4 border rounded-2xl ${t.card}`} data-testid={`moment-banner-${moment}`}>
      <span className={`inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-full ${t.icon}`}><m.Icon size={16} strokeWidth={1.4} /></span>
      <div>
        <p className="font-serif text-lg leading-tight">{m.label}</p>
        <p className={`text-xs mt-0.5 ${t.muted}`}>{m.sub}</p>
      </div>
    </div>
  );
};

export const MomentNext = ({ moment, onChange }) => {
  const other = moment === "day" ? "night" : "day"; const m = MOMENTS[other]; const t = theme[other];
  return (
    <button data-testid={`moment-next-${other}`} onClick={() => { onChange(other); window.scrollTo({ top: 0, behavior: "smooth" }); }}
      className={`mt-6 w-full flex items-center justify-between px-5 py-5 border rounded-2xl transition-transform duration-300 hover:-translate-y-0.5 ${t.card}`}>
      <span className="flex items-center gap-4">
        <span className={`inline-flex h-9 w-9 items-center justify-center rounded-full ${t.icon}`}><m.Icon size={16} strokeWidth={1.4} /></span>
        <span className="text-left">
          <span className={`block text-[10px] tracking-[0.24em] uppercase ${t.muted}`}>Continua con</span>
          <span className="block font-serif text-lg leading-tight">{m.label}</span>
        </span>
      </span>
      <ArrowRight size={18} strokeWidth={1.4} />
    </button>
  );
};
